import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorSecondary200 } from 'src/styles/colors';
import { spacing1, spacing2, spacing3 } from 'src/styles/spacing';

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing3};
  text-align: center;

  @media (min-width: ${breakpointLargeTablet}) {
    text-align: left;
  }
`;

export const StyledDescription = styled(Typography)`
  text-align: center;

  @media (min-width: ${breakpointLargeTablet}) {
    text-align: left;
  }
`;

export const StyledOrderDetails = styled.div`
  margin: ${spacing3} 0;
  border-bottom: 1px solid ${colorSecondary200};
  padding-bottom: ${spacing3};
`;

export const StyledProductTitle = styled(Typography)`
  font-weight: bold;
  text-align: left;
  margin-right: ${spacing2};
`;

export const StyledProductText = styled(Typography)`
  font-weight: bold;
  text-align: right;
`;

export const StyledProducts = styled.div`
  display: grid;
  grid-column-gap: ${spacing1};
  text-align: left;
  grid-template-rows: repeat(2, auto);
  grid-template-columns: repeat(2, auto);
`;
